<template>
    <div class="premium-stories-slider">
        <div class="container container_mob-no-p">
            <ui-slider
                v-model="valueLocal"
                dark
                mobile-full-width
                :slides-per-view="{ desktop: 3, mobile: 1 }"
                center
                no-shadow
                :autoplay="autoplay"
                @slides-zoom="slidesZoom = $event"
                @visible="visibleSlides = $event"
                @slide-progress="slideProgress = $event"
            >
                <template
                    v-for="(slide, i) in items"
                    v-slot:[`slide-${slide.id}`]
                >
                    <div
                        :key="slide.id"
                        class="premium-stories-slider__slide"
                        :class="{
                            'premium-stories-slider__slide_card': !slide.transparent,
                        }"
                        :style="{
                            transform: slide.noZoom ? 'scale(1)' : `scale(${0.76 + 0.24 * slidesZoom[i]})`,
                            opacity: slide.noZoom ? 1 : 0.76 + 0.24 * slidesZoom[i],
                        }"
                    >
                        <slot :name="`slide-${slide.id}`">
                            <div
                                class="premium-stories-slider__slide-img"
                                :style="{
                                    'background-image': `url('/local/templates/redesign/src/assets/img/premium/premium-cashback-slider/info/${slide.image}.webp')`,
                                }"
                            />
                            <div class="premium-stories-slider__slide-content _pb-32 _w-100 _dflex _flexdir-column">
                                <div class="h3 white-text _mb-16 _mr-24-24 _ml-24">{{ slide.title }}</div>
                                <div class="p1 white-text _mb-16 _mr-24-24 _ml-24" v-html="slide.subtitle"></div>
                                <div v-if="slide.mcc" class="p3 white-text _mr-24-24 _ml-24 _mt-auto">{{ slide.mcc }}</div>
                                <div v-if="slide.hasBack" class="_mr-24-24 _ml-24 _mt-auto">
                                    <button class="button button_gray-seventh button_width-100" @click="onBackToggle(slide.id, true)">
                                        Узнать подробнее
                                    </button>
                                </div>
                            </div>
                        </slot>
                        <transition name="fade">
                            <div
                                v-if="showedSlideBack[slide.id]"
                                class="premium-stories-slider__slide-back _pb-32 _w-100 _dflex _flexdir-column"
                            >
                                <div class="premium-stories-slider__slide-back-bg" />
                                <div class="premium-stories-slider__slide-back-content _position-relative">
                                    <slot :name="`slide-back-${slide.id}`" />
                                </div>
                                <div class="_mr-24-24 _ml-24 _mt-auto _position-relative">
                                    <button class="button button_gray-seventh button_width-100" @click="onBackToggle(slide.id, false)">
                                        Закрыть
                                    </button>
                                </div>
                            </div>
                        </transition>
                        <div
                            v-if="slide.label"
                            class="premium-stories-slider__slide-labels"
                        >
                            <div
                                v-if="slide.label==='new'"
                                class="_dflex"
                            >
                                <span class="_dinlblock ico ico-ahead-fill ico_color_green-premium ico_size_24 _mr-4" />
                                <span class="h4 premium-common__text_green">Новое</span>
                            </div>
                        </div>
                    </div>
                </template>
            </ui-slider>
        </div>
        <div class="premium-stories-slider__progress">
            <div
                v-for="(item, i) in items"
                :key="i"
                class="premium-stories-slider__progress-item"
                :style="{
                    '--premium-ss-slide-pgs': i === valueLocal ? slideProgress : 0,
                }"
                @click="valueLocal = i"
            />
        </div>
    </div>
</template>
<script>
export default {
    name: 'PremiumStoriesSlider',
    props: {
        value: { type: String, default: '' },
        items: { type: Array, default: () => [] },
    },
    data() {
        return {
            /**
             * i итема
             */
            valueLocal: undefined,
            slidesZoom: [],
            visibleSlides: [],
            slideProgress: 0,
            autoplayTime: 5000,
            showedSlideBack: {},
        };
    },
    computed: {
        autoplay() {
            return Object.values(this.showedSlideBack).some((val) => val) ? undefined : this.autoplayTime;
        },
    },
    watch: {
        value: {
            immediate: true,
            handler(val) {
                this.valueLocal = this.items.findIndex((item) => item.id === val);
            }
        },
        valueLocal: {
            handler(val, oldVal) {
                const index = this.items.findIndex((item) => item.id === val);
                if (index > -1 && this.value !== index) this.$emit('input', this.items[index].id);

                if (oldVal !== undefined) this.showedSlideBack[this.items[oldVal].id] = false;
            },
        },
        items: {
            immediate: true,
            deep: true,
            handler(val) {
                val.forEach(({ id }) => {
                    this.$set(this.showedSlideBack, id, this.showedSlideBack[id] ?? false);
                });
            },
        },
    },
    methods: {
        /**
         * Если возвращает 1, то слайд в центре
         * @param {number} i - номер слайда
         */
        getScaleMultiplier() {
            return 1;
        },
        onBackToggle(id, val) {
            this.showedSlideBack[id] = val ?? !this.showedSlideBack[id];
        },
    },
};
</script>
<style lang="scss">
@import '../../assets/scss/base/variables';
@import '../../assets/scss/base/functions';
@import '../../assets/scss/base/mixins';

$slide-bg: #070B11;

.premium-stories-slider {
    height: 100%;
    position: relative;
    background-color: $graphite-second;
    display: flex;
    align-items: center;

    &::before {
        content: "";
        @include fluid('--premium-ss-bg-d', 700px);
        @include fluid('--premium-ss-bg-d1', 600px);
        position: absolute;
        width: 100%;
        height: 100%;
        background: radial-gradient(var(--premium-ss-bg-d) var(--premium-ss-bg-d) at 50% 45%, #05FAFA66 0%, #00644600 100%),radial-gradient(var(--premium-ss-bg-d1) var(--premium-ss-bg-d1) at 50% 60%, #223FBBC9 0%, #223FBB00 100%);
        @include fluid('--premium-ss-bg-blur', 70px);
        filter: blur(var(--premium-ss-bg-blur));
    }

    &__slide {
        @include fluid('--premium-ss-slide-w', 384px);
        @include fluid('--premium-ss-slide-h', 653px);
        @include fluid('--premium-ss-slide-r', 24px, 0px);
        margin-left: auto;
        margin-right: auto;
        overflow: hidden;
        opacity: 0;
        transform: scale(0.76);
        will-change: opacity, transform;
        position: relative;

        @include mobile {
            --premium-ss-slide-w: 100%;
            --premium-ss-slide-h: var(--app-vh, 100vh);
        }

        width: var(--premium-ss-slide-w);
        height: var(--premium-ss-slide-h);

        &_card {
            background: $slide-bg;
            border-radius: var(--premium-ss-slide-r);
        }
    }

    &__slide-img {
        @include fluid('--premium-ss-si-h', 653px);
        height: var(--premium-ss-si-h);
        width: 100%;
        background: center / cover no-repeat;
    }

    &__slide-back {
        width: var(--premium-ss-slide-w);
        height: var(--premium-ss-slide-h);
        position: absolute;
        top: 0;
    }

    &__slide-back-bg {
        position: absolute;
        top: 0;
        width: 100%;
        height: 100%;
        background:
            top right/100% no-repeat radial-gradient(100% 70% at 90% 0%, #00b6ad91 23%, #00b6ad87 29%, #07b5a87d 35%, #07b5a863 41%, #8BAAD500 60%),
            bottom left/100% no-repeat radial-gradient(100% 70% at 0% 90%, #00b6ad91 23%, #00b6ad87 29%, #07b5a87d 35%, #07b5a863 41%, #8BAAD500 60%),
            center / 100% no-repeat linear-gradient(0deg, $slide-bg 0%, $slide-bg 100%);
    }

    &__slide-back-content {
        min-height: 1px;
    }


    &__slide-content {
        @include fluid('min-height', 240px);
        position: absolute;
        bottom: 0;
    }

    &__slide-labels {
        position: absolute;
        @include fluid('top', 24px);
        @include fluid('left', 24px);
    }

    &__progress {
        position: absolute;
        z-index: 1;
        @include fluid('width', 800px, 328px);
        @include fluid('height', 36px, 35px);
        @include fluid('gap', 8px);
        display: grid;
        grid-auto-columns: auto;
        grid-auto-flow: column;
        left: 50%;
        transform: translateX(-50%);
        @include not-mobile {
            @include fluid('bottom', 40px);
        }

        @include mobile {
            top: 0;
        }
    }

    &__progress-item {
        position: relative;
        @include fluid('height', 36px, 35px);
        @include fluid('--premium-ss-slide-pgs-h', 4px, 3px);
        border-radius: 9999px;
        cursor: pointer;
        background: center left / calc(100% * var(--premium-ss-slide-pgs)) var(--premium-ss-slide-pgs-h) no-repeat linear-gradient(0deg, $white-101 0%, $white-101 100%),
            center / 100% var(--premium-ss-slide-pgs-h) no-repeat linear-gradient(0deg, rgba($white-101, .5) 0%, rgba($white-101, .5) 100%);
    }
}
</style>
